import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import { Response } from "@/types"

export interface AttachmentMarkdownResponse {
  id: string
  name: string
  type: string
  content: string
  content_type: string
}

export const useGetAttachmentMarkdownApi = (attachmentId: string) => {
  return useCodeerApi<Response<AttachmentMarkdownResponse>>(
    `/histories/attachments/${attachmentId}/markdown`,
    FetchMethod.Get
  )
}
